import React from "react";
import Marquee from "react-fast-marquee";
import sportrexLogo from "../../assets/images/sportrex-logo.svg";
import masterCardLogo from "../../assets/images/mastercardIcon.svg"
import "./PoweredBy.css";
const PoweredBy = () => {
  return (
    <div className="power-by-container">
      <h5>Powered By:</h5>
      <Marquee speed={20}>
        <div className="power-by-partners">
          <img src={sportrexLogo} alt="Sportrex Icon" />
          <img src={masterCardLogo} alt="Sportrex Icon" />
          <img src={sportrexLogo} alt="Sportrex Icon" />
          <img src={masterCardLogo} alt="Sportrex Icon" />
        </div>
      </Marquee>
    </div>
  );
};

export default PoweredBy;
